import Vue from 'vue'
import VueResource from 'vue-resource'
import store from '../store'
import message from './msg_srv'
import { CONFIG } from '../config'
import router from '../router'
Vue.use(VueResource)

// 不需要token的api接口
var noTokenList = [
    '/login/user',
    '/sendSms',
    '/user/check',
    '/login/thirdLogin',
];
var baikeNoTokenList = [
    '/muhuo/baike/info',
    '/muhuo/baike/getHotList',
    '/muhuo/baike/getReply',
    '/muhuo/baike/getNewList',
    '/muhuo/baike/pipan/info',
    '/muhuo/baike/getBaikeLog',
    '/muhuo/baike/search',
]

// 封装基础http请求方法
var getApi = function (url, params, sucCallback, failCallback) {
    var getUrl = CONFIG.api_url + url,
        pathName = window.location.pathname;
    var getParams = Object.assign(params, CONFIG.platform_params);

    if(pathName.indexOf('embedded') != -1) {
        // embedded客户端的嵌入式页面不添加用户信息参数
        getParams = Object.assign(getParams, store.state.embedded.queryData);
    }else {
        if(store.state.userData && store.state.userData.token) {
            // 非登录接口要添加用户信息参数:::uid for test:::100033, 10002, 10001, 100719
            getParams = Object.assign(getParams, {
                token: store.state.userData.token
                // isphper: 10002
            })
        }
    }

    return new Promise((resolve, reject) => {
        Vue.http.get(getUrl, { params: getParams }, { emulateJSON: true }).then((response) => {
            if(response.data.status_code == 200) {
                if (sucCallback) {
                    sucCallback(response.data.data)
                }
                resolve();
            }else {
                if (failCallback) { 
                    failCallback(response.data)
                }
                if (response.data.status_code) {
                    console.error("请求失败", message[response.data.status_code]);
                    if(response.data.status_code == 1003 && CONFIG.platform == 'web') {
                        // 跳转回到首页
                        router.replace('/webhome');
                    }
                }
                // reject();
            }
        })
    })
}

// 注册事件，方便调用
var API = {
    // 登录方法:手机号登录
    userLogin: function (params, suc_cb, fail_cb) { getApi('/login/user', params, suc_cb, fail_cb) },
    // 登录:发送验证码
    sendLoginCode: function (params, suc_cb, fail_cb) { getApi('/sendSms', params, suc_cb, fail_cb) },
    // 检查token是否有效方法
    checkLogin: function (params, suc_cb, fail_cb) { getApi('/user/check', params, suc_cb, fail_cb) },
    // 登录方法
    thirdLogin: function (params, suc_cb, fail_cb) { getApi('/login/thirdLogin', params, suc_cb, fail_cb) },
    // 扫码登录
    getCodeLogin: function (params, suc_cb, fail_cb) { getApi('/login/getCodeLogin', params, suc_cb, fail_cb) },
    // 获取八字记录信息
    importSqg: function (params, suc_cb, fail_cb) { getApi('/muhuo/sqg', params, suc_cb, fail_cb) },
    // 获取分组、强弱、命局、药基础数据
    getUserType: function (params, suc_cb, fail_cb) { getApi('/muhuo/getUserType', params, suc_cb, fail_cb) },
    // 获取八字信息
    getDetailInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/info', params, suc_cb, fail_cb) },
    // 获取八字记录信息
    getAllList: function (params, suc_cb, fail_cb) { getApi('/muhuo/allList', params, suc_cb, fail_cb) },
    // 获取八字记录最近浏览列表
    getRecently: function (params, suc_cb, fail_cb) { getApi('/muhuo/getRecently', params, suc_cb, fail_cb) },
    // 增加排盘
    addPaiPan: function (params, suc_cb, fail_cb) { getApi('/muhuo/add', params, suc_cb, fail_cb) },
    // 修改排盘
    updatePaiPan: function (params, suc_cb, fail_cb) { getApi('/muhuo/update', params, suc_cb, fail_cb) },
    // 删除排盘
    deleteRecord: function (params, suc_cb, fail_cb) { getApi('/muhuo/del', params, suc_cb, fail_cb) },
    // 批量修改起盘分组
    changeGroup: function (params, suc_cb, fail_cb) { getApi('/muhuo/changegroup', params, suc_cb, fail_cb) },
    // 批量修改起盘最近浏览时间
    changeGlanceTime: function (params, suc_cb, fail_cb) { getApi('/muhuo/changeglancetime', params, suc_cb, fail_cb) },
    // 获取列表分享的盘数据
    getShareData: function (params, suc_cb, fail_cb) { getApi('/muhuo/getShare', params, suc_cb, fail_cb) },
    // 获取其他分享数据（批盘，反馈，反馈对照）
    getOtherShareData: function (params, suc_cb, fail_cb) { getApi('/muhuo/getOtherShare', params, suc_cb, fail_cb) },
    // 保存分享（批盘，对照，反馈）
    saveOtherShareData: function (params, suc_cb, fail_cb) { getApi('/muhuo/saveOtherShare', params, suc_cb, fail_cb) },
    // 获取他人批盘:列表数据
    getOtherShareDataList: function (params, suc_cb, fail_cb) { getApi('/muhuo/getOtherList', params, suc_cb, fail_cb) },
    // 修改他人批盘:（分享、对照）标题
    editOtherShareData: function (params, suc_cb, fail_cb) { getApi('/muhuo/editOtherList', params, suc_cb, fail_cb) },
    // 删除他人批盘:（反馈、对照）
    deleteOtherShareData: function (params, suc_cb, fail_cb) { getApi('/muhuo/delOtherList', params, suc_cb, fail_cb) },
    // 获取八字的统计数据
    getBaziNum: function (params, suc_cb, fail_cb) { getApi('/muhuo/getBaziNum', params, suc_cb, fail_cb) },
    // 获取批盘数据
    getPiPanData: function (params, suc_cb, fail_cb) { getApi('/muhuo/pipan/info', params, suc_cb, fail_cb) },
    // 修改批盘数据
    updatePiPan: function (params, suc_cb, fail_cb) { getApi('/muhuo/pipan/update', params, suc_cb, fail_cb) },
    // 获取分组列表
    getGroupList: function (params, suc_cb, fail_cb) { getApi('/muhuo/group/allList', params, suc_cb, fail_cb) },
    // 增加分组
    addGroup: function (params, suc_cb, fail_cb) { getApi('/muhuo/group/add', params, suc_cb, fail_cb) },
    // 修改分组
    updateGroup: function (params, suc_cb, fail_cb) { getApi('/muhuo/group/update', params, suc_cb, fail_cb) },
    // 删除分组
    deleteGroup: function (params, suc_cb, fail_cb) { getApi('/muhuo/group/del', params, suc_cb, fail_cb) },
    // 获取标签列表
    getLabelList: function (params, suc_cb, fail_cb) { getApi('/muhuo/label/allList', params, suc_cb, fail_cb) },
    // 增加标签
    addLabel: function (params, suc_cb, fail_cb) { getApi('/muhuo/label/add', params, suc_cb, fail_cb) },
    // 修改标签
    updateLabel: function (params, suc_cb, fail_cb) { getApi('/muhuo/label/update', params, suc_cb, fail_cb) },
    // 删除标签
    deleteLabel: function (params, suc_cb, fail_cb) { getApi('/muhuo/label/del', params, suc_cb, fail_cb) },
    // 获取命局列表
    getSituationList: function (params, suc_cb, fail_cb) { getApi('/muhuo/situation/allList', params, suc_cb, fail_cb) },
    // 增加命局
    addSituation: function (params, suc_cb, fail_cb) { getApi('/muhuo/situation/add', params, suc_cb, fail_cb) },
    // 修改命局
    updateSituation: function (params, suc_cb, fail_cb) { getApi('/muhuo/situation/update', params, suc_cb, fail_cb) },
    // 删除命局
    deleteSituation: function (params, suc_cb, fail_cb) { getApi('/muhuo/situation/del', params, suc_cb, fail_cb) },
    // 获取强弱列表
    getStrongList: function (params, suc_cb, fail_cb) { getApi('/muhuo/strong/allList', params, suc_cb, fail_cb) },
    // 增加强弱
    addStrong: function (params, suc_cb, fail_cb) { getApi('/muhuo/strong/add', params, suc_cb, fail_cb) },
    // 修改强弱
    updateStrong: function (params, suc_cb, fail_cb) { getApi('/muhuo/strong/update', params, suc_cb, fail_cb) },
    // 删除强弱
    deleteStrong: function (params, suc_cb, fail_cb) { getApi('/muhuo/strong/del', params, suc_cb, fail_cb) },
    // 获取药列表
    getMedicineList: function (params, suc_cb, fail_cb) { getApi('/muhuo/medicine/allList', params, suc_cb, fail_cb) },
    // 增加药
    addMedicine: function (params, suc_cb, fail_cb) { getApi('/muhuo/medicine/add', params, suc_cb, fail_cb) },
    // 修改药
    updateMedicine: function (params, suc_cb, fail_cb) { getApi('/muhuo/medicine/update', params, suc_cb, fail_cb) },
    // 删除药
    deleteMedicine: function (params, suc_cb, fail_cb) { getApi('/muhuo/medicine/del', params, suc_cb, fail_cb) },
    // 获取论盘列表
    getLunPanList: function (params, suc_cb, fail_cb) { getApi('/muhuo/lunpan/allList', params, suc_cb, fail_cb) },
    // 增加(保存)论盘
    addLunPan: function (params, suc_cb, fail_cb) { getApi('/muhuo/lunpan/add', params, suc_cb, fail_cb) },
    // 删除论盘
    deleteLunPan: function (params, suc_cb, fail_cb) { getApi('/muhuo/lunpan/del', params, suc_cb, fail_cb) },
    // 修改更新论盘
    updateLunPan: function (params, suc_cb, fail_cb) { getApi('/muhuo/lunpan/update', params, suc_cb, fail_cb) },
    // 获取论盘消息记录
    getLunPanMsgList: function (params, suc_cb, fail_cb) { getApi('/muhuo/lunpan/getMsgList', params, suc_cb, fail_cb) },
    // 基础配置:获取基础配置信息
    getSettingConfig: function (params, suc_cb, fail_cb) { getApi('/muhuo/config/allList', params, suc_cb, fail_cb) },
    // 基础配置:更新基础配置信息
    updateSettingConfig: function (params, suc_cb, fail_cb) { getApi('/muhuo/config/update', params, suc_cb, fail_cb) },
    // 基础配置:获取微信jssdk配置信息
    getWeixinSdkConfig: function (params, suc_cb, fail_cb) { getApi('/muhuo/config/weixinSdk', params, suc_cb, fail_cb) },
    // 基础配置:自定义扩展配置获取
    getAllExtList: function (params, suc_cb, fail_cb) { getApi('/muhuo/config/allExtList', params, suc_cb, fail_cb) },
    // 基础配置:自定义扩展配置修改或者增加
    updateExtList: function (params, suc_cb, fail_cb) { getApi('/muhuo/config/updateExt', params, suc_cb, fail_cb) },
    // 基础配置:提示数据获取
    getConfigTips: function (params, suc_cb, fail_cb) { getApi('/muhuo/config/tips', params, suc_cb, fail_cb) },
    // 支付:捐赠:获取商品列表
    getDonateProductList: function (params, suc_cb, fail_cb) { getApi('/pay/productList', params, suc_cb, fail_cb) },
    // 支付:捐赠:下单
    createDonateOrder: function (params, suc_cb, fail_cb) { getApi('/pay/createOrder', params, suc_cb, fail_cb) },
    // 捐赠:获取加油人数
    getDonateSupport: function (params, suc_cb, fail_cb) { getApi('/muhuo/support/getSupport', params, suc_cb, fail_cb) },
    // 捐赠:加油
    setDonateSupport: function (params, suc_cb, fail_cb) { getApi('/muhuo/support/setSupport', params, suc_cb, fail_cb) },
    // 捐赠:留下联系方式
    setContact: function (params, suc_cb, fail_cb) { getApi('/muhuo/support/setContact', params, suc_cb, fail_cb) },
    // AI测算:获取基础配置
    getAIConfig: function (params, suc_cb, fail_cb) { getApi('/ai/config', params, suc_cb, fail_cb) },
    // AI测算:获取测算
    getAIInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/getAiInfo', params, suc_cb, fail_cb) },
    // AI测算:使用免费机会解锁性格
    useFree: function (params, suc_cb, fail_cb) { getApi('/muhuo/useFree', params, suc_cb, fail_cb) },
    // 支付:下单
    createOrder: function (params, suc_cb, fail_cb) { getApi('/pay/createOrder', params, suc_cb, fail_cb) },
    // 百科:热门百科
    getHotList: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/getHotList', params, suc_cb, fail_cb) },
    // 百科:最新百科
    getNewList: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/getNewList', params, suc_cb, fail_cb) },
    // 百科:我的百科
    getMyList: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/getMyBaike', params, suc_cb, fail_cb) },
    // 百科:最近浏览百科
    getGlanceList: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/getGlanceList', params, suc_cb, fail_cb) },
    // 百科:我的收藏
    getCollectList: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/myCollect', params, suc_cb, fail_cb) },
    // 百科:搜索百科
    getSearchResult: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/search', params, suc_cb, fail_cb) },
    // 百科:获取百科八字信息
    getBaiKeInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/info', params, suc_cb, fail_cb) },
    // 百科:获取百科修改历史
    getBaikeLog: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/getBaikeLog', params, suc_cb, fail_cb) },
    // 百科:增加百科起盘
    addBaiKe: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/add', params, suc_cb, fail_cb) },
    // 百科:上报浏览
    updateGlanceBaiKe: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/setGlance', params, suc_cb, fail_cb) },
    // 百科:提交百科审核
    submitBaiKeCheck: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/wantCheck', params, suc_cb, fail_cb) },
    // 百科:收藏百科
    collectBaiKe: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/collect', params, suc_cb, fail_cb) },
    // 百科:取消收藏百科
    unCollectBaiKe: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/unCollect', params, suc_cb, fail_cb) },
    // 百科:点赞
    addBaiKeLike: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/addBaikeLike', params, suc_cb, fail_cb) },
    // 百科:获取百科批盘信息
    getBaiKePiPanInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/pipan/info', params, suc_cb, fail_cb) },
    // 百科:修改百科批盘
    updateBaiKePiPanInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/pipan/update', params, suc_cb, fail_cb) },
    // 百科:提交百科批盘审核
    submitBaiKePiPanCheck: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/pipan/wantCheck', params, suc_cb, fail_cb) },
    // 百科:评论:获取评论列表
    getBaiKeReplyList: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/getReply', params, suc_cb, fail_cb) },
    // 百科:评论:评论
    addBaiKeReply: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/addReply', params, suc_cb, fail_cb) },
    // 百科:评论:删除评论
    deleteBaiKeReply: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/delReply', params, suc_cb, fail_cb) },
    // 百科:评论:举报评论
    reportBaiKeReply: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/reportReply', params, suc_cb, fail_cb) },
    // 百科:评论:点赞评论
    addBaiKeReplyLike: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/addLike', params, suc_cb, fail_cb) },
    // 百科:评论:取消点赞评论
    deleteBaiKeReplyLike: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/unLike', params, suc_cb, fail_cb) },
    // 通知模块:获取通知列表
    getMsgList: function (params, suc_cb, fail_cb) { getApi('/muhuo/getMsgList', params, suc_cb, fail_cb) },
    // 通知模块:设置消息已读
    setMsgRead: function (params, suc_cb, fail_cb) { getApi('/muhuo/setMsgRead', params, suc_cb, fail_cb) },
}

export {
    API, message
}